
<div class="drawer-container">
    <div
        [@iccDrawerAnimation]="drawerAnimationState"
        class="drawer"
        [ngClass]="{ 'service-order-list': isServiceOrderList }"
        #drawer
    >
        <icc-sales-document-filters
            [filters]="filters"
            (filtersEmitter)="setFilters($event)"
            [isOrderList]="isOrderList"
            [isInquiryList]="isInquiryList"
            [isServiceOrderList]="isServiceOrderList"
            [workersList]="workersList"
            [documentStatuses]="documentStatuses"
            [showDocumentStatuses]="showDocumentStatuses"
            [side]="side"
        ></icc-sales-document-filters>

    </div>


    <div class="container">
        <div class="actions">
            <div class="actions-left">
                <button
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
                <div *ngIf="mode === 'index' && !isOrderList && !isInquiryList && hasAccessTo.createQuotation">
                    <button iccButton appearance="secondary" [disabled]="!loaded"  (click)="createOffer()" id="new-document-button">{{ 'SALES_DOCUMENT|Nowa oferta' | translate }}</button>
                </div>
                <div *ngIf="mode === 'index' && isServiceOrderList && hasAccessTo.createServiceOrder">
                    <button iccButton appearance="secondary" [disabled]="!loaded"  (click)="createServiceOrder()" id="new-document-button">{{ 'SALES_DOCUMENT|Zamów service pack' | translate }}</button>
                </div>
                <div *ngIf="mode === 'index' && isOrderList && hasAccessTo.placeOrder" class="selection-actions">
                    <span *ngIf="showGroupOptions">{{ 'INTERFACE|Zaznaczone:' | translate }}</span> <button iccButton appearance="secondary"  (click)="placeOrders()" *ngIf="showGroupOptions">{{ 'SALES_DOCUMENT|Zamów' | translate }}</button>
                </div>
                <h2 *ngIf="mode === 'selection'" translate>SALES_DOCUMENT|Wybierz dokument:</h2>
            </div>
            <div class="actions-right" *ngIf="showDebugSection || !isServiceOrderList">
                <span class="action-link-offline" (click)="switchOfflineMode(false)" [class.active]="!offline">{{ 'SALES_DOCUMENT|Lista dokumentów online' | translate}}</span>
                <span class="action-link-offline" (click)="switchOfflineMode(true)" [class.active]="offline">{{ 'SALES_DOCUMENT|Lista dokumentów offline' | translate}}</span>
                <button class="action-button-refresh" iccIconButton appearance="flat-base" (click)="updateDocuments(true)" [title]="'INTERFACE|Odśwież' | translate">
                    <icc-icon name="replay"></icc-icon>
                </button>
            </div>
        </div>

        <div class="table-container">
            <table class="documents-table">
                <thead>
                    <tr>
                        <th *ngIf="hasUnplacedOrders"></th>
                        <th>
                            <span (click)="orderBy('documentNumber')" *ngIf="!isServiceOrderList">{{ 'SALES_DOCUMENT|Numer dokumentu/Nazwa dokumentu/Kod' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['documentNumber']"></icc-sort-order-icon></span>
                            <span (click)="orderBy('documentNumber')" *ngIf="isServiceOrderList">{{ 'SALES_DOCUMENT|Numer dokumentu' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['documentNumber']"></icc-sort-order-icon></span>
                        </th>
                        <th *ngIf="side !== 'purchase'"><span (click)="orderBy('client')">{{ 'SALES_DOCUMENT|Klient' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['client']"></icc-sort-order-icon></span></th>
                        <th *ngIf="side === 'purchase'"><span (click)="orderBy('seller')">{{ 'SALES_DOCUMENT|Sprzedawca' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['seller']"></icc-sort-order-icon></span></th>
                        <th>
                            <span (click)="orderBy('created')">{{ 'SALES_DOCUMENT|Data utworzenia' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['created']"></icc-sort-order-icon></span>
                            <span (click)="orderBy('modified')">{{ 'SALES_DOCUMENT|Data modyfikacji' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['modified']"></icc-sort-order-icon></span>
                            <span (click)="orderBy('requestedDeadline')" *ngIf="side !== 'purchase' && !isInquiryList" translate>{{ 'SALES_DOCUMENT|Oczekiwana data na inwestycji' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['requestedDeadline']"></icc-sort-order-icon></span>
                        </th>
                        <th *ngIf="showDocumentStatuses"><span (click)="orderBy('status')">{{ 'SALES_DOCUMENT|Status' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['status']"></icc-sort-order-icon></span></th>
                        <th></th>
                        <th *ngIf="(side !== 'purchase' || hasAccessTo.viewBuyPrices) && !isServiceOrderList">
                            <span (click)="orderBy('priceBeforeDiscounts')">{{ 'SALES_DOCUMENT|Cena przed rabatami' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['priceBeforeDiscounts']"></icc-sort-order-icon></span>
                            <span (click)="orderBy('priceAfterDiscounts')">{{ 'SALES_DOCUMENT|Cena po rabatach' | translate }} <icc-sort-order-icon [sort]="columnSortOptions['priceAfterDiscounts']"></icc-sort-order-icon></span>
                        </th>
                        <th translate>SALES_DOCUMENT|Opcje</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let document of orderedDocuments  | paginate: { itemsPerPage: documentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
                        <ng-container *ngTemplateOutlet="documentRow; context: {document: document.doc, node: document }"></ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
        ></pagination-controls>
    </div>
</div>

<ng-template #documentRow let-document="document" let-node="node">
    <tr [class.documents-table__row--message]="node.message" [class.deleted]="document.isDeleted">
        <td class="documents-table__checkbox" *ngIf="hasUnplacedOrders">
            <icc-checkbox
                *ngIf="mode === 'index' && side === 'purchase' && documentActionsAccess.get(document.uuid)?.order"
                [name]="'document-'+document.uuid"
                [ngModel]="checkedDocuments[document.uuid]"
                (ngModelChange)="checkedDocuments[document.uuid] = $event; onChecked($event)"
                [disabled]="getDocumentSetStatus(document.uuid) !== 'synced'"
            ></icc-checkbox>
        </td>
        <td class="documents-table__name" (click)="open(document)" >
            <ng-container *ngIf="node.children?.length">
                <ng-container *ngFor="let child of node.children">
                    <span>{{ child?.documentNumber?.join ? child?.documentNumber?.join('') : '' }}
                        {{ child?.documentName ? (' / ' + child?.documentName) : '' }}</span><br>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!node.children?.length">
                {{ document?.documentNumber?.join ? document?.documentNumber?.join('') : '' }}<br>
                {{ document?.documentName }}
            </ng-container>


            <p iccBadgeChip appearance='outline' *ngIf="!isServiceOrderList">
              {{ document?.externalSource || ('SOURCE|ICC' | translate)}}
            </p>

            <span *ngIf="document?.documentCode">
                {{ document?.documentCode }}
            </span>
            <span *ngIf="document?.externalId && isServiceOrderList">
                {{ document?.externalId }}
            </span>

            <span *ngIf="mode === 'index' && side === 'sales' && documentActionsAccess.get(document.uuid)?.transferChanges" class="integrity-warning" (click)="showIntegrityWarning(document); $event.stopPropagation();">
                <br><icc-icon name="exclamation-triangle"></icc-icon> <span>{{ 'INTERFACE|Uwaga!' | translate }}</span>
            </span>
        </td>
        <td *ngIf="side !== 'purchase'" class="documents-table__client" (click)="open(document)">
          <ng-container *ngIf="document?.client?.companyName" >
            {{ document?.client?.companyName }}
            <br>
          </ng-container>
          <small *ngIf="document?.client?.firstName" >
            {{ document?.client?.firstName }}
          </small>
          <small  *ngIf="document?.client?.lastName" >
            {{ document?.client?.lastName }}
          </small>
        </td>
        <td *ngIf="side === 'purchase'" class="documents-table__client" (click)="open(document)">
            <ng-container *ngIf="node.children?.length">
                <ng-container *ngIf="hasOneSellerCompany(node.children)">
                    <ng-container *ngIf="getSellerCompany(node.children[0]) as sellerCompany" >
                        {{ sellerCompany.name }}<br>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!hasOneSellerCompany(node.children)">
                    <ng-container *ngFor="let child of node.children">
                        <ng-container *ngIf="getSellerCompany(child) as sellerCompany" >
                            {{ sellerCompany.name }}<br>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!node.children?.length">
                <ng-container *ngIf="getSellerCompany(document) as sellerCompany" >
                    {{ sellerCompany.name }}<br>
                </ng-container>
            </ng-container>

            <small *ngIf="isOrderList">
                {{ getDepartments(node.children?.length ? node.children : document) }}
            </small>
        </td>
        <td class="documents-table__date" (click)="open(document)" >
            <ng-container *ngIf="node.children?.length">
                {{ getOldestCreatedDate(node.children) | date : 'long' }}<br>
                {{ getLatestModifiedDate(node.children) | date : 'long' }}
                <ng-container *ngIf="side !== 'purchase' && !isInquiryList"><br>{{ getOldestRequestedDeadline(node.children) | date : 'long' }}</ng-container>
            </ng-container>
            <ng-container *ngIf="!node.children?.length">
                {{ document?.created | date : 'long' }}<br>
                {{ document?.modified | date : 'long' }}
                <ng-container *ngIf="side !== 'purchase' && !isInquiryList"><br>{{ document?.requestedDeadline | date : 'long' }}</ng-container>
            </ng-container>
        </td>
        <td class="documents-table__status" (click)="open(document)" *ngIf="showDocumentStatuses">
            <ng-container *ngIf="node.children?.length">
                <ng-container *ngIf="hasOneStatus(node.children)">
                    <icc-document-status [status]="getStatus(node.children[0])"></icc-document-status>
                </ng-container>
                <ng-container *ngIf="!hasOneStatus(node.children)">
                    <ng-container *ngFor="let child of node.children">
                        <icc-document-status [status]="getStatus(child)"></icc-document-status><br>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!node.children?.length">
                <icc-document-status [status]="getStatus(document)"></icc-document-status>
            </ng-container>

            <p *ngIf="isOrderList && side === 'sales' && hasUnplacedConnectedDocuments(node)" class="unplaced-producer-order">{{ 'SALES_DOCUMENT|Niezłożone u producenta' | translate }}</p>
            <p *ngIf="documentActionsAccess.get(document.uuid)?.orderInvalid && isOrderList" class="invalid-order-info">{{ 'SALES_DOCUMENT|Minął termin ważności zamówienia.' | translate }}</p>
            <p *ngIf="documentActionsAccess.get(document.uuid)?.orderInvalid && !isOrderList" class="invalid-order-info">{{ 'SALES_DOCUMENT|Minął termin ważności oferty.' | translate }}</p>
        </td>
        <td>
            <icc-synced-indicator [documents]="getDocumentSet(document.uuid)" [syncedDocuments]="synced" [online]="!offline"></icc-synced-indicator>
        </td>
        <td
            class="documents-table__price"
            (click)="open(document)"
            *ngIf="(side !== 'purchase' || hasAccessTo.viewBuyPrices) && !isServiceOrderList"
        >
            <ng-container *ngIf="node.children?.length">
                {{ sum(node.children, 'priceBeforeDiscountsValue') | currency: document?.priceCurrency }}<br>
                {{ sum(node.children, 'priceAfterDiscountsValue')  | currency: document?.priceCurrency }}
            </ng-container>
            <ng-container *ngIf="!node.children?.length">
                <ng-container *ngIf="document.hasNonValuatedPositions">
                    <span class="non-valuated">{{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span><br>
                    <ng-container *ngIf="document.priceBeforeDiscountsValue">(>{{ document.priceBeforeDiscountsValue | currency: document?.priceCurrency }})</ng-container><br>
                    <ng-container *ngIf="document.priceAfterDiscountsValue">(>{{ document.priceAfterDiscountsValue  | currency: document?.priceCurrency }})</ng-container>
                </ng-container>
                <ng-container *ngIf="!document.hasNonValuatedPositions">
                    {{ document.priceBeforeDiscountsValue | currency: document?.priceCurrency }}<br>
                    {{ document.priceAfterDiscountsValue  | currency: document?.priceCurrency }}
                </ng-container>
            </ng-container>
        </td>
        <td>
            <div class="documents-table__options">
                <button iccButton appearance="secondary"  (click)="open(document)" *ngIf="mode === 'index' && !parent && documentActionsAccess.get(document.uuid)?.open">
                  {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                </button>
                <button iccButton appearance="secondary"  (click)="select(document)" *ngIf="mode === 'selection' && !parent  && documentActionsAccess.get(document.uuid)?.select">
                  {{ 'INTERFACE|Wybierz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                </button>
                <button iccButton appearance="secondary"  (click)="copy(document, node)" *ngIf="mode === 'index' && !parent && !isOrderList && documentActionsAccess.get(document.uuid)?.copy">
                  {{ 'INTERFACE|Kopiuj' | translate }} <icc-icon name="copy"></icc-icon>
                </button>
                <button iccButton appearance="secondary"  (click)="confirmPlaceOrder(node)" *ngIf="mode === 'index' && side === 'purchase' && !parent && documentActionsAccess.get(document.uuid)?.order">
                    {{ 'SALES_DOCUMENT|Zamów' | translate }} <icc-icon name="checkmark"></icc-icon>
                </button>
                <button iccButton appearance="secondary" (click)="confirmDelete(document)" *ngIf="documentActionsAccess.get(document.uuid)?.delete">
                  <icc-icon name="delete"></icc-icon>
                </button>
                <p class="documents-table__options-orderplaced" *ngIf="node.orderPlaced">
                    {{ 'SALES_DOCUMENT|Zamówione' | translate }}
                </p>
            </div>
        </td>
    </tr>
    <tr *ngIf="node.message">
        <td [attr.colspan]="6 + (hasUnplacedOrders ? 1 : 0) + (showDocumentStatuses ? 1 : 0)" class="documents-table__message" [class.error]="node.messageState === 'error'">
            {{ node.message }}
        </td>
    </tr>
</ng-template>
